export default __webpack_public_path__ + "static/pattern-1@2x-405d02d2bcaa6ec3eb269df759180a84.png";